import React, { useEffect, useState, createContext, useContext } from 'react';
import { api } from '@/controllers/api';

interface ThemeContextType {
    primaryColor: string;
    refreshTheme: () => void;
}

const ThemeContext = createContext<ThemeContextType>({
    primaryColor: '#D4AF37',
    refreshTheme: () => { }
});

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [primaryColor, setPrimaryColor] = useState('#D4AF37');

    const applyColor = (color: string) => {
        document.documentElement.style.setProperty('--color-primary', color);
        // Mettre à jour la config Tailwind dynamiquement
        if ((window as any).tailwind?.config?.theme?.extend?.colors) {
            (window as any).tailwind.config.theme.extend.colors.primary = color;
        }
    };

    const loadSettings = async () => {
        try {
            const settings = await api.settings.get();
            if (settings.primaryColor) {
                setPrimaryColor(settings.primaryColor);
                applyColor(settings.primaryColor);
            }
        } catch (e) {
            console.error('Failed to load theme settings:', e);
        }
    };

    useEffect(() => {
        loadSettings();

        // Écouter les changements de localStorage pour la mise à jour en temps réel
        const handleStorageChange = (e: StorageEvent) => {
            if (e.key === 'settings') {
                loadSettings();
            }
        };

        window.addEventListener('storage', handleStorageChange);
        return () => window.removeEventListener('storage', handleStorageChange);
    }, []);

    const refreshTheme = () => {
        loadSettings();
    };

    return (
        <ThemeContext.Provider value={{ primaryColor, refreshTheme }}>
            {children}
        </ThemeContext.Provider>
    );
};

